import { useMutation, useQuery } from "@tanstack/react-query";
import { axiosInstance, useUtilities } from "helpers";
import { useState } from "react";

export async function uploadFiles(data, setPercentageCompleted) {
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }
  formData.append("added_by", localStorage.getItem("user_id"));
  formData.append("api_key", localStorage.getItem("apikey"));
  return axiosInstance
    .post("uploadFiles", formData, {
      onUploadProgress: (progressEvent) => {
        const percentageCompleted =
          Math.round(progressEvent.loaded * 100) / progressEvent.total;
        if (setPercentageCompleted) {
          setPercentageCompleted(percentageCompleted);
        }
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export function useUploadFiles() {
  const [percentageCompleted, setPercentageCompleted] = useState(0);
  const { notification } = useUtilities();
  return {
    percentageCompleted,
    ...useMutation((params) => uploadFiles(params, setPercentageCompleted), {
      onError: (err) =>
        notification({
          type: "error",
          message: err.message,
        }),
    }),
  };
}

async function getTimeZone() {
  return axiosInstance
    .get("catalog/timezones")
    .then((res) => res.data)
    .catch((err) => err);
}

export function useTimeZones() {
  return useQuery(["timezones"], getTimeZone);
}
